/**
 * Detect backend/exception text that should not be shown to end users
 * (e.g. Java NullPointerException messages leaked in API errorMessage).
 */
export function isTechnicalErrorMessage(message: string): boolean {
  const m = message.trim();
  if (!m) return true;

  if (/Cannot invoke\s+"/i.test(m)) return true;
  if (/\bNullPointerException\b/i.test(m)) return true;
  if (/\b(?:Exception|Error)\b/.test(m) && /\bat\s+[\w.$]+\(/.test(m)) return true;
  if (/\b(?:java|javax|jakarta|org\.springframework|com\.inova)\.[\w.]+/i.test(m)) return true;
  if (/\b[a-z]+(?:\.[a-z0-9_]+)+\.[A-Z][\w$]*\b/.test(m) && /(?:null|invoke|because)/i.test(m)) {
    return true;
  }

  return false;
}

/** Prefer a safe fallback when the API returns technical exception text. */
export function toUserFacingErrorMessage(message: string | null | undefined, fallback: string): string {
  const trimmed = typeof message === 'string' ? message.trim() : '';
  if (!trimmed || isTechnicalErrorMessage(trimmed)) return fallback;
  return trimmed;
}
